
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EditVirtualDirectoryPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domainNodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"domain"},"name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domainNodeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Domain"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baseDomain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"webScriptingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hosting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"virtualDirectory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VirtualDirectoryParentContentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRoot"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"accessSource"}},{"kind":"Field","name":{"kind":"Name","value":"accessRead"}},{"kind":"Field","name":{"kind":"Name","value":"accessWrite"}},{"kind":"Field","name":{"kind":"Name","value":"enableDirBrowsing"}},{"kind":"Field","name":{"kind":"Name","value":"dontLog"}},{"kind":"Field","name":{"kind":"Name","value":"appCreate"}},{"kind":"Field","name":{"kind":"Name","value":"scriptExecute"}},{"kind":"Field","name":{"kind":"Name","value":"aspEnableParentPaths"}},{"kind":"Field","name":{"kind":"Name","value":"aspExecuteInMTA"}},{"kind":"Field","name":{"kind":"Name","value":"authAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"authNTLM"}},{"kind":"Field","name":{"kind":"Name","value":"requireSSL"}},{"kind":"Field","name":{"kind":"Name","value":"aspBufferingLimit"}},{"kind":"Field","name":{"kind":"Name","value":"aspBufferingLimitInherited"}},{"kind":"Field","name":{"kind":"Name","value":"aspBufferingLimitDefault"}},{"kind":"Field","name":{"kind":"Name","value":"aspMaxRequestEntityAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"aspMaxRequestEntityAllowedInherited"}},{"kind":"Field","name":{"kind":"Name","value":"aspMaxRequestEntityAllowedDefault"}},{"kind":"Field","name":{"kind":"Name","value":"aspEnableServerDebug"}},{"kind":"Field","name":{"kind":"Name","value":"aspEnableServerDebugInherited"}},{"kind":"Field","name":{"kind":"Name","value":"aspEnableServerDebugDefault"}},{"kind":"Field","name":{"kind":"Name","value":"aspEnableClientDebug"}},{"kind":"Field","name":{"kind":"Name","value":"aspEnableClientDebugInherited"}},{"kind":"Field","name":{"kind":"Name","value":"aspEnableClientDebugDefault"}},{"kind":"Field","name":{"kind":"Name","value":"enableDefaultDoc"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDocs"}}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1952}};
    doc.loc.source = {"body":"#import \"queries/VirtualDirectoryParentContentFragment.graphql\"\n\nquery EditVirtualDirectoryPage(\n    $domainNodeId: ID!,\n    $path: String!,\n) {\n    domain: node(id: $domainNodeId) {\n        ... on Domain {\n            id\n            baseDomain {\n                id\n            }\n            webScriptingSettings {\n                asp\n            }\n            hosting {\n                virtualDirectory (path: $path) {\n                    key\n                    parent {\n                        key\n                        ...VirtualDirectoryParentContentFragment\n                    }\n                    properties {\n                        isRoot\n                        isEditable\n                        name\n                        path\n                        accessSource\n                        accessRead\n                        accessWrite\n                        enableDirBrowsing\n                        dontLog\n                        appCreate\n                        scriptExecute\n                        aspEnableParentPaths\n                        aspExecuteInMTA\n                        authAnonymous\n                        authNTLM\n                        requireSSL\n                        aspBufferingLimit\n                        aspBufferingLimitInherited\n                        aspBufferingLimitDefault\n                        aspMaxRequestEntityAllowed\n                        aspMaxRequestEntityAllowedInherited\n                        aspMaxRequestEntityAllowedDefault\n                        aspEnableServerDebug\n                        aspEnableServerDebugInherited\n                        aspEnableServerDebugDefault\n                        aspEnableClientDebug\n                        aspEnableClientDebugInherited\n                        aspEnableClientDebugDefault\n                        enableDefaultDoc\n                        defaultDocs\n                    }\n                }\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("queries/VirtualDirectoryParentContentFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["EditVirtualDirectoryPage"] = oneQuery(doc, "EditVirtualDirectoryPage");
        
